import axios from 'axios'
import _get from 'lodash/get'

export const PENSIONS_AND_BENEFITS_GET = 'PENSIONS_AND_BENEFITS_GET'
export const PENSIONS_AND_BENEFITS_UPDATE = 'PENSIONS_AND_BENEFITS_UPDATE'
export const PENSIONS_AND_BENEFITS_SAVE = 'PENSIONS_AND_BENEFITS_SAVE'
export const PENSIONS_AND_BENEFITS_SAVING = 'PENSIONS_AND_BENEFITS_SAVING'
export const PENSIONS_AND_BENEFITS_SAVE_SUCCESS = 'PENSIONS_AND_BENEFITS_SAVE_SUCCESS'
export const PENSIONS_AND_BENEFITS_SAVE_ERROR = 'PENSIONS_AND_BENEFITS_SAVE_ERROR'

export const requestPensionsAndBenefits = (selfAssessmentId) => (dispatch) =>
    axios
        .get(`/pensionsandbenefits/${selfAssessmentId}`)
        .then((response) => {
            const pensionsAndBenefits = { ...response.data, shouldFetch: false, fetchSuccessful: true }

            dispatch(updatePensionsAndBenefits(pensionsAndBenefits))
        })
        .catch((error) => {
            if (_get(error, ['response', 'status']) === 404) {
                dispatch(updatePensionsAndBenefits({ shouldFetch: false, fetchSuccessful: true }))
            }
        })

export const updatePensionsAndBenefits = (pensionsAndBenefits) => ({
    type: PENSIONS_AND_BENEFITS_UPDATE,
    pensionsAndBenefits,
})

export const savePensionsAndBenefits = () => (dispatch, getState) => {
    const { assessment, pensionsAndBenefits } = getState()

    dispatch(pensionsAndBenefitsSaving, pensionsAndBenefits)

    axios
        .put(`/pensionsandbenefits/${assessment.id}`, { ...pensionsAndBenefits, selfAssessmentId: assessment.id })
        .then((response) => {
            const data = {
                ...response.data,
                isAllowanceUpdate: pensionsAndBenefits.isAllowanceUpdate,
                shouldGoToNextAllowanceQuestion: pensionsAndBenefits.shouldGoToNextAllowanceQuestion,
            }

            dispatch(pensionsAndBenefitsSaveSuccess(data))
        })
        .catch((error) => {
            dispatch(pensionsAndBenefitsSaveError(pensionsAndBenefits, _get(error, ['response', 'data'])))
        })
}

export const updateAndSavePensionsAndBenefits = (pensionsAndBenefits) => (dispatch) => {
    dispatch(updatePensionsAndBenefits(pensionsAndBenefits))
    dispatch(savePensionsAndBenefits())
}

const pensionsAndBenefitsSaving = (pensionsAndBenefits) => ({
    type: PENSIONS_AND_BENEFITS_SAVING,
    pensionsAndBenefits,
})

const pensionsAndBenefitsSaveSuccess = (pensionsAndBenefits) => ({
    type: PENSIONS_AND_BENEFITS_SAVE_SUCCESS,
    pensionsAndBenefits,
})

const pensionsAndBenefitsSaveError = (pensionsAndBenefits, errorResponse) => ({
    type: PENSIONS_AND_BENEFITS_SAVE_ERROR,
    pensionsAndBenefits,
    errorResponse,
})
